var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.1,
    height: 10.8,
    viewBox: "0 0 15.1 10.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_319",
    "data-name": "Pfad 319",
    d: "M6.5,10.8,0,4.3,2.1,2.2,6.5,6.5,13,0l2.1,2.1Z",
    fill: "#c5d75d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalka);
export default __webpack_public_path__ + "static/media/galka.b7cd798806706fa47c9b11a9ae7b71b3.svg";
export { ForwardRef as ReactComponent };